import React, { useState, useEffect } from "react";
import Flatpickr from "react-flatpickr";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, Card, CardBody, Modal,ModalHeader,ModalBody, ModalFooter } from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useSelector } from "react-redux";
import moment from 'moment';
import Loader from "../../Components/Common/Loader";

export default function RoiCalculation() {
  const [step, setStep] = useState(1);
  const [revenuePillarsDD, setRevenuePillarsDD] = useState({});
  const [measurementTypeDD, setMeasurementTypeDD] = useState("");
  const [coursesDD, setCoursesDD] = useState({});
  const [KPIsDD, setKPIsDD] = useState({});
  const [mealPeriodDD, setMealPeriodDD] = useState([]);
  const [measurement, setMeasurement] = useState("");
  const [measurementText, setMeasurementText] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedItemText, setSelectedItemText] = useState("");
  const [itemsDD, setItemsDD] = useState([]);
  const [discountCodesDD, setDiscountCodesDD] = useState([]);
  const [currency, setCurrency] = useState('$');
  const { courses, mealperiod, currentOutlet } = useSelector((state) => ({
      courses: state.Dashboard.filterData.courses || [],
      mealperiod: state.Dashboard.filterData.mealperiod,
      currentOutlet: state.UserOutletGroup.currentOutlet
  }));
  useEffect(()=>{
      setCoursesDD(courses);
      setMealPeriodDD(mealperiod);
  },[courses,mealperiod])
  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency);
    }
  }, [currentOutlet]);
  
  const [measurementType, setMeasurementType] = useState("");
  const [testFrom, setTestFrom] = useState(null);
  const [testTo, setTestTo] = useState(null);
  const [controlFrom, setControlFrom] = useState(null);
  const [controlTo, setControlTo] = useState(null);
  const [servingPeriod, setServingPeriod] = useState("");
  const [servingPeriodText, setServingPeriodText] = useState("");
  const [selectedDays, setSelectedDays] = useState(["All"]); 

  const [fromTime, setFromTime] = useState(null);
  const [toTime, setToTime] = useState(null);

  const [action, setAction] = useState("");
  const [revenuePillar, setRevenuePillar] = useState("");
  const [showROIList, setShowROIList] = useState(true);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [roiList, setRoiList] = useState([]);
  const [selectedROI, setSelectedROI] = useState(null);
  const [editROI, setEditROI] = useState(null);
  const [refreshList, setRefreshList] = useState(true);
  const [listLoading, setListLoading] = useState(false);


  const [roiData, setRoiData] = useState({
    targetQty: 0,
    targetRevenue: 0,
    avgCheck: 0,
    controlQty: 0,
    controlRevenue: 0,
    controlAvgCheck: 0,
    roi: 0,
    percentIncrease: 0,
  });


const calculateROI = () => {
  let targetQty = 0; 
  let targetRevenue = 0;
  let avgCheck = 0;

  let controlQty = 0;
  let controlRevenue = 0;
  let controlAvgCheck = 0;

  let targetTableTurnTime = 0;
  let controlTableTurnTime = 0;
  
  let targetTableOccupancy = 0;
  let controlTableOccupancy = 0;
  let controlCovers = 0;
  let targetCovers = 0;
  
    if (!action || !revenuePillar || !measurementType || !measurement || !controlFrom || !controlTo || !testFrom || !testTo ) {
      alert("Please fill all required fields!");
      return;
    }
    const formattedTestFrom    = testFrom    ? moment(testFrom).format("YYYY-MM-DD") : "";
    const formattedTestTo      = testTo      ? moment(testTo).format("YYYY-MM-DD") : "";
    const formattedControlFrom = controlFrom ? moment(controlFrom).format("YYYY-MM-DD") : "";
    const formattedControlTo   = controlTo   ? moment(controlTo).format("YYYY-MM-DD") : "";
    const formattedFromTime   = fromTime   ? moment(fromTime).format("HH:mm") : "";
    const formattedToTime  = toTime   ? moment(toTime).format("HH:mm") : "";
    const additional_data = [action, revenuePillar, servingPeriodText, selectedItemText, measurementText]
    setLoading(true);
    const controller = new AbortController();
    postDataAPI({
        serviceName: 'kpi_data',
        op: 'roi_calculation',
        testFrom: formattedTestFrom,
        testTo: formattedTestTo,
        controlFrom: formattedControlFrom,
        controlTo: formattedControlTo,
        servingPeriod,
        selectedDays,
        fromTime: formattedFromTime,
        toTime: formattedToTime,
        measurement,
        selectedItem,
        measurementType,
        additional_data
    }, controller.signal).then((response) => {
        setLoading(false);
        if (response.status === "ok") {
          controlQty = Number(response.data?.control_result?.item_sold) || 0;
          controlRevenue = Number(response.data?.control_result?.total_sales) || 0;
          controlCovers = Number(response.data?.control_result?.total_covers) || 0;
          if (controlCovers) {
            controlAvgCheck = (controlRevenue/controlCovers);
          }

          targetQty = Number(response.data?.test_result?.item_sold) || 0;
          targetRevenue = Number(response.data?.test_result?.total_sales) || 0;
          targetCovers = Number(response.data?.test_result?.total_covers) || 0;
          if (targetCovers) {
            avgCheck = (targetRevenue/targetCovers);
          }

          if (measurement === "Table Turn") {
            const ttDurationControl = Number(response.data?.control_result?.duration) || 0;
            const ttChkCountControl = Number(response.data?.control_result?.chk_count) || 0;
            const ttDurationTest = Number(response.data?.test_result?.duration) || 0;
            const ttChkCountTest = Number(response.data?.test_result?.chk_count) || 0;
            if(ttChkCountControl>0){
              controlTableTurnTime = ttDurationControl / ttChkCountControl;
            }
            if(ttChkCountTest>0){
              targetTableTurnTime = ttDurationTest / ttChkCountTest;
            }
          }
          if (measurement === "Occupancy Rate") {
            const cDuration = Number(response.data?.control_result?.duration) || 0;
            const tDuration = Number(response.data?.test_result?.duration) || 0;
            const ctbl_duration = Number(response.data?.control_result?.tbl_duration) || 0;
            const ttbl_duration = Number(response.data?.test_result?.tbl_duration) || 0;
            if (ctbl_duration > 0) {
              controlTableOccupancy = cDuration/(ctbl_duration)*100;
            }
            if (ttbl_duration > 0) {
              targetTableOccupancy =tDuration/(ttbl_duration)*100;
            }
          }

          let roi; 
          let percentIncrease;
          if (measurement === "Covers") {
            roi = targetCovers - controlCovers;
            percentIncrease = controlCovers === 0 ? -100 : ((roi / controlCovers) * 100);
          } else if (measurement === "Average Check") {
            roi = avgCheck - controlAvgCheck;
            percentIncrease = controlAvgCheck === 0 ? -100 : ((roi / controlAvgCheck) * 100);
          } else if (measurement === "Table Turn") {
            roi = targetTableTurnTime - controlTableTurnTime;
            percentIncrease = controlTableTurnTime === 0 ? -100 : ((roi / controlTableTurnTime) * 100);
          } else if (measurement === "Occupancy Rate") {
            roi = targetTableOccupancy - controlTableOccupancy;
            percentIncrease = controlTableOccupancy === 0 ? -100 : ((roi / controlTableOccupancy) * 100);
          } else {
            roi = targetRevenue - controlRevenue;
            percentIncrease = controlRevenue === 0 ? -100 : ((roi / controlRevenue) * 100);
          }

          
          setRoiData({
            targetQty,
            targetRevenue,
            avgCheck,
            controlQty,
            controlRevenue,
            controlAvgCheck,
            roi,
            percentIncrease,
            controlTableTurnTime,
            targetTableTurnTime,
            controlTableOccupancy,
            targetTableOccupancy,
            controlCovers,
            targetCovers
          });
          setShowROIList(true);
          setRefreshList(!refreshList);
        }
    });
    return () => {
        controller.abort();
    };
};


  const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => s - 1);

  const toggleDaySelection = (day) => {
  if (day === "All") {
    // If clicking ALL → make only ALL active
    setSelectedDays(["All"]);
  } else {
    // Remove "All" if selecting any other day
    let updated = selectedDays.includes("All")
      ? []
      : [...selectedDays];

    if (updated.includes(day)) {
      updated = updated.filter((d) => d !== day);
    } else {
      updated.push(day);
    }

    // If none selected, revert to "All"
    if (updated.length === 0) {
      updated = ["All"];
    }

    setSelectedDays(updated);
  }
};

useEffect(() => {
  const controller = new AbortController();
  postDataAPI({
        serviceName: 'kpi_data',
        op: 'kpi_filter'
    }, controller.signal).then((response) => {
        if (response.status === "ok") {
          setRevenuePillarsDD(response.data.revenue_pillar);
          setMeasurementTypeDD(response.data.measurement_type);
          setKPIsDD(response.data.dynamic_dropdown.Kpis);
          setDiscountCodesDD(response.data.discount_codes);
        }
    });
    return () => {
        controller.abort();
    };
}, []);

useEffect(() => {
  const controller = new AbortController();
  setListLoading(true);
  postDataAPI({
        serviceName: 'kpi_data',
        op: 'roi_calculation_list'
    }, controller.signal).then((response) => {
        setListLoading(false);
        if (response.status === "ok") {
          setRoiList(response.data);
        }
    });
    return () => {
        controller.abort();
    };
}, [refreshList]);

const loadItemsByCourse = (courseId) => {
  if (!courseId) return;

  postDataAPI({
    serviceName: "item_data",
    op: "fetch_item_dropdown",
    course_id: courseId,
    limit: 700
  }).then((res) => {
    if (res.status === "ok") {
      setItemsDD(res.data); // Expect array [{id:1, name:'Tea'}]
    }
  });
};

const validateStep2 = () => {
  if (!testFrom || !testTo || !controlFrom || !controlTo) {
    alert("Please fill in all date fields.");
    return false;
  }

  if (testTo < testFrom) {
    alert("Test To date must be greater than Test From date.");
    return false;
  }

  if (controlTo < controlFrom) {
    alert("Control To date must be greater than Control From date.");
    return false;
  }

  return true;
};

const validateDateRange = () => {
  // Convert inputs to Date objects
  const cFrom = new Date(controlFrom);
  const cTo = new Date(controlTo);
  const tFrom = new Date(testFrom);
  const tTo = new Date(testTo);

  // Calculate day counts (inclusive)
  const controlDays =
    Math.floor((cTo - cFrom) / (1000 * 60 * 60 * 24)) + 1;

  const testDays =
    Math.floor((tTo - tFrom) / (1000 * 60 * 60 * 24)) + 1;

  // Compare day count instead of dates
  if (controlDays !== testDays) {
    const proceed = window.confirm(
      `Warning: Period Length Mismatch\nThe control period (${controlDays} days) does not match the test period (${testDays} days).\nThis may affect the accuracy of your ROI calculations.\n\nDo you want to continue anyway?`
    );

    if (proceed) {
      nextStep(); // user confirmed → move ahead
    }
    return; // stop if rejected
  }

  // If identical day count → proceed directly
  nextStep();
};

const loadROIForEdit = (row) => {
  const filters = JSON.parse(row.roi_filters || "{}");

  // Fill step-1 fields
  setAction(filters.action || "");
  setRevenuePillar(filters.revenuePillar || "");

  // Fill step-2 fields (dates)
// Always use moment to safely convert API dates for Flatpickr
setTestFrom(filters.test_from ? moment(filters.test_from, "YYYY-MM-DD").toDate() : null);
setTestTo(filters.test_to ? moment(filters.test_to, "YYYY-MM-DD").toDate() : null);

setControlFrom(filters.control_from ? moment(filters.control_from, "YYYY-MM-DD").toDate() : null);
setControlTo(filters.control_to ? moment(filters.control_to, "YYYY-MM-DD").toDate() : null);


  // Step-3 fields
  setMeasurementType(filters.measurement_type || "");
  setMeasurement(filters.measurement || "");
  setMeasurementText(filters.measurementText || "");
  setSelectedItem(filters.selected_item || "");
  setSelectedItemText(filters.selectedItemText || "");

  // Step-4 fields
  setServingPeriod(filters.serving_period || "");
  setServingPeriodText(filters.servingPeriodText || "");
  setSelectedDays(filters.selected_days?.length ? filters.selected_days : ["All"]);

  setFromTime(filters.from_time ? moment(filters.from_time, "HH:mm").toDate() : null);
  setToTime(filters.to_time ? moment(filters.to_time, "HH:mm").toDate() : null);

  // Load items list if it's "Individual Items"
  if (filters.measurement_type === "Individual Items" && filters.measurement) {
    loadItemsByCourse(filters.measurement);
  }

  setStep(5);
  setEditROI(row);
  setShowROIList(false);
  
};

const resetROIForm = () => {
  setStep(1);
  setAction("");
  setRevenuePillar("");

  setMeasurementType("");
  setMeasurement("");
  setMeasurementText("");
  setSelectedItem("");
  setSelectedItemText("");

  setTestFrom(null);
  setTestTo(null);
  setControlFrom(null);
  setControlTo(null);

  setServingPeriod("");
  setServingPeriodText("");
  setSelectedDays(["All"]);

  setFromTime(null);
  setToTime(null);

  setEditROI(null);        // clear edit mode
  setRoiData({});
};

const computeQtyPercentOfCovers = (calc) => {
  const targetCovers = Number(calc.targetCovers || 0);
  const actualCovers = Number(calc.controlCovers || 0);
  const targetQty = Number(calc.targetQty || 0);
  const actualQty = Number(calc.controlQty || 0);

  const targetRatio = targetCovers > 0 ? targetQty / targetCovers : null;
  const actualRatio = actualCovers > 0 ? actualQty / actualCovers : null;

  if (targetRatio === null || actualRatio === null || targetRatio === 0) {
    return null;
  }

  return (actualRatio / targetRatio) * 100 - 100;
};

const deleteROI = async (roiId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this record?");
  if (!confirmDelete) return;

  try {
    postDataAPI({
        serviceName: 'kpi_data',
        op: 'roi_calculation_delete',
        row_id: roiId
    }).then((response) => {
        if (response.status === "ok") {
          setRefreshList(!refreshList);
        }
    });

  } catch (error) {
    console.error("Delete error:", error);
    alert("Something went wrong while deleting");
  }
};


  return (
    <React.Fragment>
          <div className="page-content">
            <Container fluid>
              <BreadCrumb title="ROI Calculations" pageTitle="Dashboard" />
              {listLoading && <Loader />}
              {!showROIList && (
              <div>
              <Row className="justify-content-center">
                <Col>
                  <Card>
                    <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h2 className="mb-0">ROI Calculations</h2>

                      <div
                        className="d-flex align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowROIList(true)}
                      >
                        <i className="ri-arrow-left-line me-2"></i>
                        <span>Back to List</span>
                      </div>
                    </div>


                    {/* Step 1 */}
                    <div style={{ display: step >= 1 ? "block" : "none", paddingTop:"30px" }} className="ribbon-box">
                        <div className="ribbon ribbon-danger round-shape">Define Action & Revenue Pillar</div>
                        <div className="ribbon-content mt-4 text-muted">
                    <Row>
                      <Col md={6}>
                        <FormGroup className="mb-3">
                        <Label>Action*</Label>
                        {/* <Input type="text" placeholder="e.g., Increase tea by 1" defaultValue={action} onBlur={(e) => setAction(e.target.value)} /> */}
                        <Input
                          type="text"
                          placeholder="e.g., Increase tea by 1"
                          value={action}
                          onChange={(e) => setAction(e.target.value)}
                        />

                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-3">
                          <Label>Revenue Pillar*</Label>
                          <Input type="select" required
                                value={revenuePillar}
                                onChange={(e) => setRevenuePillar(e.target.value)}>
                            <option value="">Select revenue pillar</option>
                            {Object.keys(revenuePillarsDD).map((key) => (
                              <option key={key} value={key}>
                                {revenuePillarsDD[key]}
                              </option>
                            ))}

                          </Input>
                        </FormGroup>
                      </Col>
                      </Row>
                    {step === 1 && (
                        <div className="d-flex justify-content-end">
                        <Button color="danger" onClick={nextStep}>Next</Button>
                        </div>
                    )}
                    </div>
                    </div>

                                {/* Step 2 */}
                                {/* Step 2 */}
                    <div
                      style={{ display: step >= 2 ? "block" : "none", paddingTop: "30px" }}
                      className="ribbon-box"
                    >
                       <div className="ribbon ribbon-primary round-shape">Define the Target Timeframe</div>

                      <div className="ribbon-content mt-4 text-muted">

                        {/* --------------------------- */}
                        {/* TESTING PERIOD SECTION      */}
                        {/* --------------------------- */}
                        <h6 className="mb-3">Testing Period (Future or Historical)</h6>

                        <Row className="mb-4">
                          <Col md={6}>
                            <FormGroup>
                              <Label>From*</Label>
                              <Flatpickr
                                className="form-control"
                                placeholder="dd-mm-yyyy"
                                value={testFrom}
                                onChange={(date) => setTestFrom(date[0])}
                                options={{ dateFormat: "d-m-Y" }}
                              />
                            </FormGroup>
                          </Col>

                          <Col md={6}>
                            <FormGroup>
                              <Label>To*</Label>
                              <Flatpickr
                                className="form-control"
                                placeholder="dd-mm-yyyy"
                                value={testTo}
                                onChange={(date) => setTestTo(date[0])}
                                options={{ dateFormat: "d-m-Y", minDate: testFrom || null }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        {/* --------------------------- */}
                        {/* CONTROL PERIOD SECTION      */}
                        {/* --------------------------- */}
                        <h6 className="mb-3">Control Period (Benchmark Range)</h6>

                        <Row className="mb-4">
                          <Col md={6}>
                            <FormGroup>
                              <Label>From*</Label>
                              <Flatpickr
                                className="form-control"
                                placeholder="dd-mm-yyyy"
                                value={controlFrom}
                                onChange={(date) => {
                                  setControlFrom(date[0]);
                                  if (controlTo && date[0] > controlTo) {
                                    setControlTo(null);
                                  }
                                }}
                                options={{ dateFormat: "d-m-Y", maxDate: "today" }}
                              />
                            </FormGroup>
                          </Col>

                          <Col md={6}>
                            <FormGroup>
                              <Label>To*</Label>
                              <Flatpickr
                                className="form-control"
                                placeholder="dd-mm-yyyy"
                                value={controlTo}
                                onChange={(date) => setControlTo(date[0])}
                                options={{ dateFormat: "d-m-Y", maxDate: "today",minDate: controlFrom || null }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <hr />

                        {step === 2 && (
                          <div className="d-flex justify-content-between">
                            <Button color="secondary" onClick={prevStep}>
                              Previous
                            </Button>

                            <Button color="danger" onClick={() => {
                                if (validateStep2()) {
                                  validateDateRange();
                                  //nextStep();
                                }
                              }}>
                              Next
                            </Button>
                          </div>
                        )}
                      </div>
                      
                    </div>



                                {/* Step 3 */}
                                {/* Step 3 */}
                    <div
                      style={{ display: step >= 3 ? "block" : "none", paddingTop: "30px" }}
                      className="ribbon-box"
                    >                     
                      <div className="ribbon ribbon-primary round-shape">What to Measure</div>

                      <div className="ribbon-content mt-4 text-muted">
                        <Row>
                          <Col md={6}>
                            <FormGroup className="mb-3">
                              <Label>Measurement Type*</Label>
                              <Input
                                type="select"
                                required
                                value={measurementType}
                                onChange={(e) => {setMeasurementType(e.target.value); setSelectedItemText(""); setMeasurement(""); setMeasurementText(""); setSelectedItem("")}}
                              >
                                <option value="">Select what to measure</option>
                                {Object.keys(measurementTypeDD).map((key) => (
                                  <option key={key} value={key}>
                                    {measurementTypeDD[key]}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>

                          {/* Dynamic Second Dropdown */}
                          {measurementType !== "" && (
                            <Col md={6}>
                              <FormGroup className="mb-3">
                                <Label>
                                  {measurementType === "Courses"
                                    ? "Which Course*"
                                    : measurementType === "Individual Items"
                                    ? "Which Course*"
                                    : measurementType === "KPIs"
                                    ? "Which KPI*"
                                    : "Discount Type*"}
                                </Label>

                                <Input
                                  type="select"
                                  required
                                  value={measurement}
                                  onChange={(e) => {
                                    const selected = e.target.value;
                                    const selectedLabel = e.target.options[e.target.selectedIndex].text;
                                    setMeasurementText(selectedLabel);
                                    setMeasurement(selected);

                                    // Trigger API when Measurement Type = Individual Items
                                    if (measurementType === "Individual Items") {
                                      loadItemsByCourse(selected);
                                    }
                                  }}
                                >
                                  {(measurementType === "Courses" ||
                                    measurementType === "Individual Items") && (
                                    <>
                                      <option value="">Select course</option>
                                      {coursesDD.length > 0 &&
                                        coursesDD.map((course) => (
                                          <option key={course.value} value={course.value}>
                                            {course.label}
                                          </option>
                                        ))}
                                    </>
                                  )}

                                  {measurementType === "KPIs" && (
                                    <>
                                      <option value="">Select KPI</option>
                                      {Object.keys(KPIsDD).map((key) => (
                                        <option key={key} value={key}>
                                          {KPIsDD[key]}
                                        </option>
                                      ))}
                                    </>
                                  )}

                                  {measurementType === "Promotion" && (
                                    <>
                                      <option value="">Select discount</option>

                                      {discountCodesDD.length > 0 &&
                                        discountCodesDD.map((d, index) => (
                                          <option key={index} value={d.discount_name}>
                                            {d.discount_name}
                                          </option>
                                        ))
                                      }
                                    </>
                                  )}
                                </Input>
                              </FormGroup>
                            </Col>
                          )}

                          {measurementType === "Individual Items" && measurement !== "" && (
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label>Which Item*</Label>

                                  <Input type="select" required
                                    value={selectedItem}
                                     onChange={(e) => {
                                        const value = e.target.value;
                                        const selected = itemsDD.find((item) => item.value === value);

                                        setSelectedItem(value);
                                        setSelectedItemText(selected?.label);
                                      }}
                                  >
                                    {/* <option value="all">All</option> */}

                                    {itemsDD.length > 0 &&
                                      itemsDD.map((item) => (
                                        <option key={item.value} value={item.value}>
                                          {item.label}
                                        </option>
                                      ))}
                                  </Input>
                                </FormGroup>
                              </Col>
                            )}
                        </Row>

                        {step === 3 && (
                          <div className="d-flex justify-content-between">
                            <Button color="secondary" onClick={prevStep}>
                              Previous
                            </Button>
                            <Button color="danger" onClick={nextStep}>Next</Button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div
                      style={{ display: step >= 4 ? "block" : "none", paddingTop: "30px" }}
                      className="ribbon-box"
                    >
                      <div className="ribbon ribbon-primary round-shape">Fine-Tuning & Filters</div>

                      <div className="ribbon-content mt-4 text-muted">
                        
                        {/* --------------------------- */}
                        {/* SERVING PERIOD DROPDOWN     */}
                        {/* --------------------------- */}
                        <FormGroup className="mb-4">
                          <Label>Serving Period</Label>
                          <Input
                            type="select"
                            value={servingPeriod}
                            //onChange={(e) => setServingPeriod(e.target.value)}
                            onChange={(e) => {
                              const value = e.target.value;
                              const selected = mealPeriodDD.find((item) => item.sp_id === value);

                              setServingPeriod(value);
                              if (value==="custom") {
                                setServingPeriodText("Custom");
                                setFromTime(null);
                                setToTime(null);
                              } else {
                                setServingPeriodText(selected?.title);
                              }
                              
                              if (selected?.start_time && selected?.end_time) {
                                const today = new Date().toISOString().split("T")[0]; // dummy date
                                setFromTime(new Date(`${today} ${selected.start_time}`));
                                setToTime(new Date(`${today} ${selected.end_time}`));
                              }
                              }}
                          >
                            <option value="">Select serving period</option>                            
                            {mealPeriodDD.length > 0 &&
                              mealPeriodDD.map((item) => {
                                  return (
                                  <option key={item.sp_id} value={item.sp_id}>
                                          {item.title +
                                        " (" +
                                        item.start_time +
                                        " To " +
                                        item.end_time +
                                        ")"}
                                  </option>
                                  );
                              })}
                            <option value="custom">Custom</option>
                          </Input>
                        </FormGroup>

                        {/* --------------------------- */}
                        {/* DAY OF WEEK MULTI SELECT    */}
                        {/* --------------------------- */}
                        <Label className="mb-2">Day of Week</Label>
                        
                        <div className="d-flex flex-wrap mb-4">
                          {[
                            "All",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat",
                            "Sun",
                          ].map((day) => (
                            <FormGroup check className="me-3" key={day}>
                              <Input
                                type="checkbox"
                                checked={selectedDays.includes(day)}
                                onChange={() => toggleDaySelection(day)}
                              />
                              <Label check>{day}</Label>
                            </FormGroup>
                          ))}
                        </div>

                        {/* --------------------------- */}
                        {/* HOURS TIME PICKER           */}
                        {/* --------------------------- */}
                        <Label className="mb-2">Hours Filter (Optional)</Label>

                        <Row className="mb-4">
                          <Col md={6}>
                            <FormGroup>
                              <Label>From</Label>
                              <Flatpickr
                                className="form-control"
                                value={fromTime}
                                onChange={(t) => setFromTime(t[0])}
                                options={{
                                  enableTime: true,
                                  noCalendar: true,
                                  dateFormat: "H:i",
                                  time_24hr: true,
                                  inline: false,
                                }}
                                placeholder="Select time"
                              />
                            </FormGroup>
                          </Col>

                          <Col md={6}>
                            <FormGroup>
                              <Label>To</Label>
                              <Flatpickr
                                className="form-control"
                                value={toTime}
                                onChange={(t) => setToTime(t[0])}
                                options={{
                                  enableTime: true,
                                  noCalendar: true,
                                  dateFormat: "H:i",
                                  time_24hr: true,
                                  inline: false,
                                }}
                                placeholder="Select time"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        

                        {step === 4 && (
                          <div className="d-flex justify-content-between">
                            <Button color="secondary" onClick={prevStep}>
                              Previous
                            </Button>

                            <Button color="danger" onClick={nextStep}>
                              Next
                            </Button>
                          </div>
                        )}

                      </div>
                    </div>

                    {/* STEP 5 — SUMMARY */}
                    <div
                      style={{ display: step >= 5 ? "block" : "none", paddingTop: "30px" }}
                      className="ribbon-box"
                    >
                      <div className="ribbon ribbon-primary round-shape">Summary</div>

                      <div className="ribbon-content mt-4">

                        <div className="p-4 rounded" style={{ background: "#fafafa", border: "1px solid #eee" }}>

                          <p><strong>Action:</strong> {action || "Not specified"}</p>

                          <p><strong>Revenue Pillar:</strong> {revenuePillar || "Not specified"}</p>

                          <p><strong>Measurement Type:</strong> {measurementType || "Not specified"}</p>
                          
                          {measurementType === "Individual Items" ? (
                            <>
                              <p>
                                <strong>Selected Course:</strong> {measurementText || "Not specified"}
                              </p>
                              <p>
                                <strong>Specific Measurement:</strong> {selectedItemText || "Not specified"}
                              </p>
                            </>
                          ) : (
                            <p>
                              <strong>{measurementType === "Promotion" ? "Discount Type" : "Specific Measurement" }:</strong> {measurementText || "Not specified"}
                            </p>
                          )}

                          <p>
                            <strong>Testing Period:</strong>{" "}
                            {testFrom && testTo
                              ? `${moment(testFrom).format("YYYY-MM-DD")} to ${moment(testTo).format("YYYY-MM-DD")}`
                              : "Not specified"}
                          </p>

                          <p>
                            <strong>Control Period:</strong>{" "}
                            {controlFrom && controlTo
                              ? `${moment(controlFrom).format("YYYY-MM-DD")} to ${moment(controlTo).format("YYYY-MM-DD")}`
                              : "Not specified"}
                          </p>


                          <p>
                            <strong>Serving Period:</strong> {servingPeriodText || "Not specified"}
                          </p>

                          <p>
                            <strong>Days:</strong>{" "}
                            {selectedDays.length > 0 ? selectedDays.join(", ") : "Not specified"}
                          </p>

                         <p>
                          <strong>Hours:</strong>{" "}
                          {fromTime && toTime
                            ? `${moment(fromTime, "HH:mm").format("HH:mm")} - ${moment(toTime, "HH:mm").format("HH:mm")}`
                            : "Not specified"}
                        </p>


                        </div>

                        <hr className="my-4" />

                        <div className="d-flex justify-content-between">
                          <Button color="secondary" onClick={prevStep}>
                            Previous
                          </Button>

                          <Button
                            color="danger"
                            disabled={loading}
                            onClick={calculateROI}
                          >
                            {loading ? "Loading..." : "Calculate ROI"}
                          </Button>

                        </div>
                      </div>
                    </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              </div>)}

              {showROIList && (
                // <Row className="justify-content-center">
                // <Col>
                  <Card>
                    <CardBody>                    
                    <div>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="mb-0"></h5>
                              <Button
                                color="primary"
                                onClick={() => {
                                  resetROIForm();
                                  setShowROIList(false);   // show form
                                }}
                              >
                                + Add New
                              </Button>
                            </div>


                            {roiList && roiList.length > 0 && roiList.map((row, index) => {

                              const filters = JSON.parse(row.roi_filters || "{}");
                              const control = JSON.parse(row.roi_control_results || "{}");
                              const test = JSON.parse(row.roi_test_results || "{}");
                              const calc = JSON.parse(row.roi_calculated_result || "{}");

                              const measurement = filters.measurement;
                              const selectedItemText = filters.selectedItemText || "ALL";
                              const servingPeriodText = filters.servingPeriodText || "-";

                              return (
                                <>
                                <h3 className="mb-2 d-flex align-items-center gap-2">
                                  ROI – {filters.action}
                                  <i
                                    className="ri-information-line"
                                    style={{ cursor: "pointer", fontSize: "22px" }}
                                    onClick={() => {
                                      setSelectedROI({
                                        row,
                                        filters,
                                        control,
                                        test,
                                        calc
                                      });
                                      setShowSummaryModal(true);
                                    }}
                                  ></i>

                                </h3>
                                <div className="table-responsive mb-4">
                                <table className="table align-middle table-nowrap table-bordered mb-0">
                                <thead className="table-light">
                                    <tr style={{ textAlign: 'center',verticalAlign: "middle" }}>
                                      <th scope="col" rowSpan={2}>Item</th>
                                      <th scope="col" rowSpan={2}>FROM</th>
                                      <th scope="col" rowSpan={2}>TO</th>
                                      <th scope="col" rowSpan={2}>Serving <br />Period</th>
                                      <th scope="col" colSpan={measurement === "Table Turn" || measurement === "Occupancy Rate" ? 6 : 5}>Target</th>
                                      <th scope="col" colSpan={measurement === "Table Turn" || measurement === "Occupancy Rate" ? 6 : 5}>Acutal / Control period</th>
                                      <th scope="col" rowSpan={2}>ROI</th>
                                      <th scope="col" rowSpan={2}>%</th>
                                      <th scope="col" rowSpan={2}>Action</th>                                 
                                    </tr>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th scope="col">Covers </th>
                                        <th scope="col">Qty </th>
                                        <th scope="col">Q%</th>
                                        <th scope="col">Revenue</th>
                                        <th scope="col">Avg. <br />Check</th>
                                        {measurement === "Table Turn" && (
                                          <th scope="col">Table Turn</th>
                                        )}
                                        {measurement === "Occupancy Rate" && (
                                          <th scope="col">Occupancy %</th>
                                        )}
                                        <th scope="col">Covers </th>
                                        <th scope="col">Qty</th>
                                        <th scope="col">Q%</th>
                                        <th scope="col">Revenue</th>
                                        <th scope="col">Avg. <br />Check</th>
                                        {measurement === "Table Turn" && (
                                          <th scope="col">Table Turn</th>
                                        )}
                                        {measurement === "Occupancy Rate" && (
                                          <th scope="col">Occupancy %</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                <tr key={index}>
                                  <td className="text-start">{selectedItemText}</td>

                                  <td className="text-center">
                                    {filters.control_from ? moment(filters.control_from).format("YYYY-MM-DD") : ""}
                                  </td>
                                  <td className="text-center">
                                    {filters.control_to ? moment(filters.control_to).format("YYYY-MM-DD") : ""}
                                  </td>

                                  <td className="text-center">{servingPeriodText}</td>

                                  {/* Target */}
                                  <td className="text-center">{calc.targetCovers}</td>
                                  <td className="text-center">{calc.targetQty}</td>
                                  <td className="text-center">{Number((calc.targetQty / calc.targetCovers) * 100 || 0).toFixed(2)}%</td>
                                  <td className="text-center">{currency}{Number(calc.targetRevenue || 0).toFixed(2)}</td>
                                  <td className="text-center">{currency}{Number(calc.avgCheck || 0).toFixed(2)}</td>

                                  {measurement === "Table Turn" && (
                                    <td className="text-center">{Number(calc.targetTableTurnTime || 0).toFixed(2)}</td>
                                  )}

                                  {measurement === "Occupancy Rate" && (
                                    <td className="text-center">{Number(calc.targetTableOccupancy || 0).toFixed(2)}%</td>
                                  )}

                                  {/* Actual / Control */}
                                  <td className="text-center">{calc.controlCovers}</td>
                                  <td className="text-center">{calc.controlQty}</td>
                                  <td className="text-center">{Number((calc.controlQty / calc.controlCovers) * 100 || 0).toFixed(2)}%</td>
                                  <td className="text-center">{currency}{Number(calc.controlRevenue || 0).toFixed(2)}</td>
                                  <td className="text-center">{currency}{Number(calc.controlAvgCheck || 0).toFixed(2)}</td>

                                  {measurement === "Table Turn" && (
                                    <td className="text-center">{Number(calc.controlTableTurnTime || 0).toFixed(2)}</td>
                                  )}

                                  {measurement === "Occupancy Rate" && (
                                    <td className="text-center">{Number(calc.controlTableOccupancy || 0).toFixed(2)}%</td>
                                  )}

                                  {/* ROI */}
                                  <td
                                    style={{ color: Number(calc.roi) < 0 ? "red" : "green" }}
                                    className="text-center"
                                  >
                                    {currency}{Number(calc.roi || 0).toFixed(2)}
                                  </td>

                                  <td
                                    style={{ color: Number(calc.percentIncrease) < 0 ? "red" : "green" }}
                                    className="text-center"
                                  >
                                    {Number(calc.percentIncrease || 0).toFixed(1)}%
                                  </td>

                                  {/* Action */}
                                  <td className="text-center">
                                    <i
                                        className="ri-edit-line me-2"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => loadROIForEdit(row)}
                                      ></i>
                                    <i
                                      className="ri-delete-bin-line text-danger"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => deleteROI(row.roi_id)}
                                    ></i>
                                  </td>
                                </tr>
                             
                                </tbody>

                              </table>
                              </div>
                              </>
                       );
                            })}
                    </div>
                    </CardBody>
                  </Card>
              //   </Col>
              // </Row>
            )}

      </Container>
      </div>
      <Modal isOpen={showSummaryModal} toggle={() => setShowSummaryModal(false)}>
        <ModalHeader toggle={() => setShowSummaryModal(false)}>
          Summary
        </ModalHeader>

        <ModalBody>

        {selectedROI ? (
          <>
            <p>
              <strong>Action:</strong>{" "}
              {selectedROI.filters?.action || "Not specified"}
            </p>

            <p>
              <strong>Revenue Pillar:</strong>{" "}
              {selectedROI.filters?.revenuePillar || "Not specified"}
            </p>

            <p>
              <strong>Measurement Type:</strong>{" "}
              {selectedROI.filters?.measurement_type || "Not specified"}
            </p>

            {selectedROI.filters?.measurement_type === "Individual Items" ? (
              <>
                <p>
                  <strong>Selected Course:</strong>{" "}
                  {selectedROI.filters?.measurementText || "Not specified"}
                </p>
                <p>
                  <strong>Specific Measurement:</strong>{" "}
                  {selectedROI.filters?.selectedItemText || "Not specified"}
                </p>
              </>
            ) : (
              <p>
                <strong>
                  {selectedROI.filters?.measurement_type === "Promotion"
                    ? "Discount Type"
                    : "Specific Measurement"}
                  :
                </strong>{" "}
                {selectedROI.filters?.measurementText || "Not specified"}
              </p>
            )}

            <p>
              <strong>Testing Period:</strong>{" "}
              {selectedROI.filters?.test_from && selectedROI.filters?.test_to
                ? `${moment(selectedROI.filters.test_from).format("YYYY-MM-DD")} to ${moment(selectedROI.filters.test_to).format("YYYY-MM-DD")}`
                : "Not specified"}
            </p>

            <p>
              <strong>Control Period:</strong>{" "}
              {selectedROI.filters?.control_from && selectedROI.filters?.control_to
                ? `${moment(selectedROI.filters.control_from).format("YYYY-MM-DD")} to ${moment(selectedROI.filters.control_to).format("YYYY-MM-DD")}`
                : "Not specified"}
            </p>

            <p>
              <strong>Serving Period:</strong>{" "}
              {selectedROI.filters?.servingPeriodText || "Not specified"}
            </p>

            <p>
              <strong>Days:</strong>{" "}
              {selectedROI.filters?.selected_days?.length > 0
                ? selectedROI.filters.selected_days.join(", ")
                : "Not specified"}
            </p>

            <p>
              <strong>Hours:</strong>{" "}
              {selectedROI.filters?.from_time && selectedROI.filters?.to_time
                ? `${moment(selectedROI.filters.from_time, "HH:mm").format("HH:mm")} - ${moment(selectedROI.filters.to_time, "HH:mm").format("HH:mm")}`
                : "Not specified"}
            </p>
          </>
        ) : (
          <p>No summary data available</p>
        )}


        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={() => setShowSummaryModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      </React.Fragment>
  );
}
